import { render, staticRenderFns } from "./CommissionsPolicyChart.vue?vue&type=template&id=ed0a8c16"
import script from "./CommissionsPolicyChart.vue?vue&type=script&lang=js"
export * from "./CommissionsPolicyChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports